module.exports = __webpack_public_path__ + "img/saudia-8.a10a252f.png";